import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Organizations", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("New Organization ")
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus el-icon-right" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Export CSV ")
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-document el-icon-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_container = _resolveComponent("el-container")
  const _component_OrgList = _resolveComponent("OrgList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: _ctx.routeToNewOrg }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          class: "flex-align-right",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportOrgsAndDownload(_ctx.orgs.map(org => org.id))))
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_OrgList)
  ], 64))
}